import { createFileRoute } from '@tanstack/react-router'

import { UsersPage } from '@/components/pages/Admin/Users/UsersPage'

export const Route = createFileRoute('/_liff/admin/users')({
  component: UsersPage,
})
